/**
 * Default axApply.
 */
export function axDefaultApply(self, args) {
    return this.axCoerce(args ? args[0] : undefined);
}
